import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/functions';

firebase.initializeApp({
  apiKey: 'AIzaSyBLZpitRybduRmzwJA-LMMayAMfllL9CJw',
  authDomain: 'max-towers.firebaseapp.com',
  databaseURL: 'https://max-towers.firebaseio.com',
  projectId: 'max-towers',
  storageBucket: 'max-towers.appspot.com',
  messagingSenderId: '730117487387'
});

export const auth = firebase.auth();
export const database = firebase.database();
export const storage = firebase.storage();
export const functions = firebase.functions();

// functions.useFunctionsEmulator('http://localhost:5000');

const fs = firebase.firestore();
export const firestore = fs;

export default firebase;
